import * as React from 'react'
import { Row, Col, Input, Button, message, Descriptions, Card, PageHeader } from 'antd';
import { RouteComponentProps, withRouter } from 'react-router';

import SERVICE_IDENTIFIER from '../../wires/Identifiers'
import container from '../../wires/Bootstrapper'
import { SupportoModel } from '../../models/SupportoModel';
import { ISupportoService } from '../../services/SupportoService';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { ai } from '../../TelemetryService';



class SupportoState extends SupportoModel {
    UserMessage: string
}


export class PageSupportoComp extends React.Component<RouteComponentProps, SupportoState>{

    service: ISupportoService;

    constructor(props) {
        super(props)
        this.service = container.get(SERVICE_IDENTIFIER.SUPPORT_SERVICE);
        this.state = new SupportoState();
    }

    onSend = async () => {
        let resp = await this.service.InviaRichiesta(this.state.UserMessage)
        if (resp.IsValid) {
            message.success("Richiesta di supporto inviata con successo. Il nostro team di help desk ti risponderà al più presto", 5)
            this.setState({ UserMessage: "" })
        }
    }

    componentDidMount() {
        this.loadPage()
    }

    loadPage = async () => {
        let resp = await this.service.RenderSupporto()
        if (resp.IsValid)
            this.setState(resp)
    }

    renderOrari = (orari?: Array<string>) => {
        if (orari == null) return ""
        return this.state.OrariUfficio.map((orari, i) => <span>{orari}<br /></span>)
    }

    downloadStaticFile = (fileName:string) => {
        this.service.DownloadStaticFile(fileName)
    }

    render() {
        return (
            <PageHeader title="Help & Support">
                <Row>
                    <Col span={12}>
                        <Card bordered={false} title="Visualize s.rl">
                            <Descriptions layout="vertical">
                                <Descriptions.Item label="Numero di telefono">
                                    <a target="_blank" href={`tel:${this.state.Telefono}`}>{this.state.Telefono}</a>
                                </Descriptions.Item>
                                
                                <Descriptions.Item label="Orari Apertura Uffici">
                                    {this.renderOrari(this.state.OrariUfficio)}
                                </Descriptions.Item>
                            </Descriptions>
                        </Card>
                    </Col>
                    <Col span={12}>
                        <Card bordered={false} title="Manuale e condizioni d'uso di Business Financial Coach">
                            Per consultare la guida utente di Business Financial Coach <a target="_blank" rel="noopener noreferrer" href={this.state.LinkStart}>clicca qui</a><br />
                            {
                            /* 
                             * come da specifiche del bkl il link relativo alle condizioni attualmente è fittizio.
                             * qual'ora si dovesse puntare ad un file pdf come per il manuale sostituire href con onClick={() => this.downloadStaticFile(this.state.LinkCondizioni)}
                             */
                            }
                            Per consultare le condizioni d'uso di Business Financial Coach <a target="_blank" rel="noopener noreferrer" href={this.state.LinkCondizioni}>clicca qui</a><br />
                            Non hai trovato quello che cercavi? Contattaci utilizzando la form sottostante!
                        </Card>
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col span={24}>
                        <Card bordered={false} title="Richiesta di supporto" className="card-full-height">
                            <p>Inserisci la tua richiesta di supporto nel campo di testo qui sotto e clicca "Invia" per inviarla a Visualize s.rl.<br />
                                Il nostro team di help desk ti risponderà al più presto.
                            </p>
                            <Row >
                                <Col span={24}>
                                    <Input.TextArea value={this.state.UserMessage} onChange={e => this.setState({ UserMessage: e.target.value })} rows={10} />
                                </Col>
                            </Row>
                            <br />
                            <Row justify="end">
                                <Col><Button type="primary" onClick={() => this.onSend()}>Invia</Button></Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
            </PageHeader>
        )
    }
}
export const PageSupporto = withRouter(withAITracking(ai.reactPlugin, PageSupportoComp, "PageSupporto"))